module.exports = __webpack_public_path__ + "assets/img/u5e70701af2447.086e38ab.png";